import { render } from "./LabelOrderNewPage.vue?vue&type=template&id=2a12f5c0&scoped=true"
import script from "./LabelOrderNewPage.vue?vue&type=script&lang=js"
export * from "./LabelOrderNewPage.vue?vue&type=script&lang=js"

import "./LabelOrderNewPage.vue?vue&type=style&index=0&id=2a12f5c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a12f5c0"]])

export default __exports__